module.exports = __webpack_public_path__ + "static/media/Small-Scale-Development.828b4d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Small-Scale-Development.png
// module id = 131
// module chunks = 0